import { ClubStepPath } from './models/new-registration.models';

/** Single URL root for the new registration flow (`/club-registration` redirects here). */
export const NEW_REGISTRATION_BASE = '/new-registration';

/** Registration History list, or one event's registration detail. */
export function newRegistrationHistoryLink(eventId?: string): string[] {
  return eventId ? [NEW_REGISTRATION_BASE, 'history', eventId] : [NEW_REGISTRATION_BASE, 'history'];
}

/** Router commands for an event's wizard, optionally at a step: `['/new-registration', id, 'stays']`. */
export function newRegistrationLink(eventId: string | number, step?: ClubStepPath): string[] {
  const id = String(eventId);
  return step ? [NEW_REGISTRATION_BASE, id, step] : [NEW_REGISTRATION_BASE, id];
}
